import React, { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { listResources } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { MagnifyingGlass, Copy, BookOpen } from "@phosphor-icons/react";
import { toast } from "sonner";

export const MarketingResources = () => {
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("");
  const { data } = useQuery({ queryKey: ["resources", q, cat], queryFn: () => listResources({ q, category: cat }) });
  const rows = data?.resources || [];
  const cats = data?.categories || [];
  const copy = (r) => { navigator.clipboard.writeText(r.body); toast.success(`"${r.title}" copied — paste and personalize the [placeholders]`); };
  return (
    <div data-testid="marketing-resources">
      <div className="relative mb-4">
        <MagnifyingGlass size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-[#5a5a5a]" />
        <Input data-testid="resources-search" value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Search all resources — try 'cold email', 'objection', 'win-back'…"
          className="bg-[#10101A] border-white/10 pl-8 h-9 max-w-md text-sm" />
      </div>
      <div className="flex items-center gap-1.5 flex-wrap mb-5" data-testid="resources-categories">
        <button data-testid="resources-cat-all" onClick={() => setCat("")}
          className={`text-xs px-2.5 py-1.5 rounded-full border ${!cat ? "border-[#6B3DFF]/40 bg-[#6B3DFF]/10 text-white" : "border-white/12 text-[#9a9a9a] hover:text-white"}`}>All</button>
        {cats.map((c) => (
          <button key={c} data-testid={`resources-cat-${c.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} onClick={() => setCat(c === cat ? "" : c)}
            className={`text-xs px-2.5 py-1.5 rounded-full border ${cat === c ? "border-[#6B3DFF]/40 bg-[#6B3DFF]/10 text-white" : "border-white/12 text-[#9a9a9a] hover:text-white"}`}>{c}</button>
        ))}
      </div>
      <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4" data-testid="resources-grid">
        {rows.map((r) => (
          <div key={r.id} className="card-matte p-4 flex flex-col" data-testid={`resource-card-${r.id}`}>
            <div className="flex items-start justify-between gap-2">
              <div>
                <div className="font-semibold text-sm">{r.title}</div>
                <span className="inline-block mt-1 text-[9px] px-1.5 py-0.5 rounded bg-[#6B3DFF]/12 text-[#C39BFF]">{r.category}</span>
              </div>
              <BookOpen size={16} className="text-[#5a5a5a] shrink-0" />
            </div>
            <pre className="mt-3 text-[11px] text-[#9a9a9a] whitespace-pre-wrap font-sans leading-relaxed bg-[#10101A] border border-white/8 rounded-lg p-3 max-h-40 overflow-y-auto flex-1">{r.body}</pre>
            <button data-testid={`resource-copy-${r.id}`} onClick={() => copy(r)}
              className="mt-3 flex items-center justify-center gap-1.5 text-xs font-semibold text-white bg-[#6B3DFF] hover:bg-[#A56CFF] rounded-full h-8 transition-colors">
              <Copy size={13} /> Copy to clipboard
            </button>
          </div>
        ))}
      </div>
      {!rows.length && <div className="text-center text-sm text-[#7a7a7a] py-10" data-testid="resources-empty">No resources match "{q}" — try another word.</div>}
    </div>
  );
};
